import { Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';


@Component({
    selector: 'app-uig-product-identifiers',
    templateUrl: './uig-product-identifiers.component.html',
    styleUrls: ['./uig-product-identifiers.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductIdentifiersComponent implements OnInit {

  product$: Observable<Product> = this.currentProductService.getProduct();

  constructor(private currentProductService: CurrentProductService) { }

  ngOnInit(): void {
  }

}
